export const MFA_CHALLENGE_INTERACTION_IDS = {
  SELECT_TOTP: '1glJiQSQMz',
  SELECT_SMS: 'kraHOXuK2J',
  VERIFY_OTP: 'oneTimeCodeId',
  VERIFY_TOTP: 'oneTimeCodeId',
  RESEND_OTP: 'resend',
  TRUST_DEVICE_NO: 'UwfHCan_hY',
  TRUST_DEVICE_YES: 'aq-gpqbGD-',
} as const;
